import Online from './online';
import Fishing from './fishing';
import Slots from './slots';

export default {
    Online,
    Fishing,
    Slots
}